import config from '~/config';

export const roundedHumanFormat = (
	currency: string,
	value: string,
	maximumFractionDigits = 2,
	locale: string[] = config.locale
): string => {
	const options = {
		currency: currency,
		style: 'currency',
		minimumFractionDigits: 2,
		maximumFractionDigits,
		currencyDisplay: 'code',
	};
	try {
		return Intl.NumberFormat(locale, options)
			.format(Number(value))
			.replace(/([A-Z]) ?([0-9])/, '$1\xA0$2');
	} catch {
		return 'N/A';
	}
};

export const roundedHumanFormatWithoutCurrency = (
	value: string,
	maximumFractionDigits = 2,
	locale: string[] = config.locale
): string => {
	const options = {
		style: 'decimal',
		minimumFractionDigits: 2,
		maximumFractionDigits,
		currencyDisplay: 'code',
	};
	return Intl.NumberFormat(locale, options)
		.format(Number(value))
		.replace(/([A-Z]) ?([0-9])/, '$1\xA0$2');
};

export default class Price {
	value: string;

	currency: string;

	constructor(value: string, currency: string) {
		this.value = value;
		this.currency = currency;
	}

	roundedHumanFormat(maximumFractionDigits = 2, locale: string[] = config.locale): string {
		return roundedHumanFormat(this.currency, this.value, maximumFractionDigits, locale);
	}

	humanFormat(locale: string[] = config.locale): string {
		return this.roundedHumanFormat(20, locale);
	}

	roundedValue(digits = 2): number {
		return Number(Number(this.value).toFixed(digits));
	}

	equals(other: any): boolean {
		return other instanceof Price && this.currency === other.currency && this.roundedValue() === other.roundedValue();
	}
}
